import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { HiOutlineCheckCircle } from "react-icons/hi2";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const ExtenderSolicitud = () => {
  const query = useQuery();
  const reserva_id = query.get("reserva_id");
  const dia = query.get("dia");
  const hora_inicio = query.get("hora_inicio");
  const hora_final = query.get("hora_final");
  const correo_tecnico = query.get("correo_tecnico");

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [reserva, setReserva] = useState(null);

  useEffect(() => {
    const agregarItinerario = async () => {
      try {
        const id_token = query.get("id_token");
        const activacion = await axios.put("https://desarrollotecnologicoar.com/api5/activar_token_web", { id: id_token });
        if (!activacion.data.success) {
          alert(activacion.data.message);
          setLoading(false);
          return;
        }
        const response = await axios.get(`https://desarrollotecnologicoar.com/api5/reserva_id/${reserva_id}`);
        setReserva(response.data);
        await axios.post("https://desarrollotecnologicoar.com/api5/itinerario_ticket_extension", {
          reserva_id,
          itinerario: [{ fecha: dia, entrada: hora_inicio, salida: hora_final }],
        }, { headers: { "Content-Type": "application/json" } });
        setSuccess(true);
      } catch (err) {
        console.error("Error al extender la solicitud:", err);
      } finally {
        setLoading(false);
      }
    };
    if (reserva_id && dia && hora_inicio && hora_final && correo_tecnico) {
      agregarItinerario();
    } else {
      setLoading(false);
    }
  }, [reserva_id, dia, hora_inicio, hora_final, correo_tecnico]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <svg className="w-10 h-10 animate-spin text-slate-400" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      {success ? (
        <div className="card p-8 max-w-md w-full text-center">
          <HiOutlineCheckCircle className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-slate-900 mb-4">Extension agregada exitosamente!</h1>
          <div className="space-y-2 text-sm text-left">
            {[
              { label: "Empresa", value: reserva?.empresa },
              { label: "Ticket", value: reserva?.ticket },
              { label: "Contacto", value: reserva?.contacto },
              { label: "Equipo", value: reserva?.equipo },
              { label: "Ciudad", value: reserva?.ciudad },
              { label: "Nuevo dia", value: `${dia} de ${hora_inicio} a ${hora_final}` },
            ].map((item) => (
              <div key={item.label} className="flex justify-between py-1.5 border-b border-slate-100">
                <span className="text-slate-500">{item.label}</span>
                <span className="font-medium text-slate-800">{item.value}</span>
              </div>
            ))}
          </div>
          <a href="/" className="btn-primary mt-6 inline-flex">Volver al inicio</a>
        </div>
      ) : (
        <div className="text-center">
          <p className="text-lg font-semibold text-slate-800">No se pudo extender la solicitud.</p>
          <p className="text-sm text-slate-500 mt-1">Este token ya fue activado desde la web.</p>
        </div>
      )}
    </div>
  );
};
